const BASE_URL = process.env.REACT_APP_API_URL;

export const API_CONFIG = {
  baseUrl: BASE_URL,
  verificationUrl: `${BASE_URL}showverifications`,
  saveUrl: `${BASE_URL}saveincome`,
  searchUrl: `${BASE_URL}registerperson`,
  loginUrl: `${BASE_URL}login`,
  changePasswordUrl: `${BASE_URL}changePassword`,
  getUsersUrl: `${BASE_URL}getusers`,
  saveUserUrl: `${BASE_URL}saveuser`,
  submitApplicationUrl: `${BASE_URL}submitapplication`,
  applicationsListUrl: `${BASE_URL}applications/list`,
  applicationsSaveUrl: `${BASE_URL}applications/save`,
  applicationsStatusUrl: `${BASE_URL}applications/status`,
  applicationsCommentUrl: `${BASE_URL}applications/comment`,
  tenantsListUrl: `${BASE_URL}tenants/list`,
  leadsListUrl: `${BASE_URL}leads/list`,
  leadsInboxListUrl: `${BASE_URL}leads/inbox/list`,
  leadsSaveUrl: `${BASE_URL}leads/save`,
  leadsStatusUrl: `${BASE_URL}leads/status`,
  leadsCommentUrl: `${BASE_URL}leads/comment`,
  leadsConvertUrl: `${BASE_URL}leads/convert`,
  bookingsListUrl: `${BASE_URL}bookings/list`,
  bookingsSaveUrl: `${BASE_URL}bookings/save`,
  bookingsStatusUrl: `${BASE_URL}bookings/status`,
  bookingsCommentUrl: `${BASE_URL}bookings/comment`,
  quotationsListUrl: `${BASE_URL}quotations/list`,
  quotationsSaveUrl: `${BASE_URL}quotations/save`,
  quotationsStatusUrl: `${BASE_URL}quotations/status`,
  invoicesListUrl: `${BASE_URL}invoices/list`,
  invoicesSaveUrl: `${BASE_URL}invoices/save`,
  invoicesStatusUrl: `${BASE_URL}invoices/status`,
  notificationsListUrl: `${BASE_URL}notifications/list`,
  notificationsSaveUrl: `${BASE_URL}notifications/save`,
  reportsSummaryUrl: `${BASE_URL}reports/summary`,
  auditLogsUrl: `${BASE_URL}audit/logs`,
  automationAdvanceUrl: `${BASE_URL}automation/advance`,
  apiKey: process.env.REACT_APP_VERSION,
};
